import { Pipe, PipeTransform } from '@angular/core';
import { camelToSnakeCase } from '@shared/utils/camel-to-snake.util';

@Pipe({
  name: 'documentTypeName',
})
export class DocumentTypeNamePipe implements PipeTransform {
  transform(name: string): string {
    return `candidates.${camelToSnakeCase(name)}`;
  }
}
